@if (store) {
<div class="flex flex-column wrap p-l-12-x store-modal">
    <div class="flex flex-justify-between p-t-8">
        <h1 class="h3">{{store.data.store_name | translate}}</h1>
        <button (click)="close()"
                type="button"
                aria-label="Close">
            <i class="icon-close"
               aria-hidden="true"></i>
        </button>
    </div>
    <div class="flex p-b-2">
        <store-open-status [store]="store"></store-open-status>
    </div>
    <div class="flex flex-justify-between p-t-6 p-b-10">
        <div class="flex flex-column flex-wrap">
            <p class="p1 p-t-2 p-b-2">{{store.data.address}}</p>
            <p class="p1">{{store.data.city}}, {{store.data.postcode}}</p>
            <p class="p1 p-t-2">{{store.data.email}}</p>
        </div>
        <div class="flex flex-column">
            @if (store.data?.owner_name) {
            <div class="pos-relative m-t-2">
                <href class="m-l-7 block"
                      [link]="store.data?.url">
                    <i class="icon-earth pos-absolute top-50 left-0 p-l-1"></i>
                    <span class="p1">{{store.data.owner_name}}</span>
                </href>
            </div>
            }
            @if (store.data.phone) {
            <div class="pos-relative m-t-2">
                <a class="m-l-7 block"
                   [attr.href]="'tel:' + store.data.phone">
                    <span class="p1">{{store.data.phone}}</span>
                    <i class="icon-phone pos-absolute top-50 left-0 p-l-1"></i>
                </a>
            </div>
            }
            <!-- get direction -->
            <a class="w-12 m-t-2"
               [attr.href]="store.directions"
               target="_blank">
                <i class="icon-location m-r-2 p-l-1"></i>
                <span class="p1">{{'Get directions' | translate}}</span>
            </a>
        </div>
    </div>
    <div class="b-b p-b-8 b-t p-t-8"
         *ifTradeStore>
        @for (day of weeklySchedule; track $index) {
        <div class="flex flex-justify-between p-b-1 p-t-2">
            <p class="p1">{{day.date | date :'EEEE'}}</p>
            @switch (day.status) {
            @case (1) {
            <p class="p1 col-12">{{day.open}}AM - {{day.close}}PM</p>
            }
            @case (2) {
            <p class="p1 col-12">{{'Closed' | translate}}</p>
            }
            }
        </div>
        }
    </div>
    @if (store.storeFeatures) {
    <div class="p-t-8">
        <p class="s1">{{'Features' | translate}}</p>
        <div class="flex flex-wrap w-12 p-t-4">
            @for (featureId of store.storeFeatures; track $index) {
            <div class="flex flex-middle w-5 w-3-m p-b-2">
                <div class="w-1 ratio-1-1 m-r-2">
                    <img class="rf"
                         [image]="featureId | optionImage : 'store_features'">
                </div>
                <div class="p1">{{featureId | optionLabel : 'store_features'}}</div>
            </div>
            }
        </div>
    </div>
    }
</div>
}